import styled from 'styled-components'


export const TwoColumnsGridContainer = styled.div`
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 16px;
`
